define(function(require) {
	// general
	const CN = require('civicsUtils/constants');
	const tpl = require('civicsViews/attachments/templates/t_cpv_attributes.hbs');
	// views
	const itemView = require('civicsViews/attachments/v_itv_attribute_item');


	return Marionette.CompositeView.extend({
		initialize: function(options) {
			this.config = options.config;
			this.numDisplayedAttributes = options.numDisplayedAttributes;
			this.collection = options.collection;
			this.canUpdate = options.canUpdate;
			this.attachment_index = options.attachment_index
		},
		template: tpl,
		childView: itemView,
		childViewContainer: function() {
			// The target (in the composite view) for the item rows
			return '.attributes-item-view-container'
		},
		childViewOptions: function(model, index) {
			return {
				config: this.config,
				numDisplayedAttributes: this.numDisplayedAttributes,
				collection: this.collection,
				disableFields: !this.canUpdate,
				attachment_index:this.attachment_index
			};
		},
		className: 'list-view',
		ui: {},
		events: {},
		onRender: function() {},
		templateHelpers: function() {
			var self = this;
			var helpers = {};
			return helpers;
		}
	});
});